export enum DurationType {
    Tick = 1,
    Millisecond = 2,
    Seconds = 3
}

export function formatDuration(duration: number, type: DurationType) {
    const milliseconds =
        type == DurationType.Tick
            ? Math.floor(duration / DurationType.Millisecond)
            : type == DurationType.Millisecond
              ? duration
              : type == DurationType.Seconds
                ? duration * 1000
                : 0;

    const date = new Date(milliseconds);
    const days = Math.round(milliseconds / (1000 * 60 * 60 * 24)),
        hours = date.getUTCHours(),
        minutes = date.getUTCMinutes(),
        seconds = date.getUTCSeconds(),
        showMilliseconds = hours === 0 && minutes === 0 && seconds === 0;

    return `${days > 0 ? days + "d " : ""}${hours > 0 ? hours + "h " : ""}${minutes > 0 ? minutes + "m " : ""}${seconds > 0 ? seconds + "s " : ""}${showMilliseconds ? date.getUTCMilliseconds() + " ms" : ""}`;
}
